import { useState } from "react";
import PageHero from "../components/PageHero";
import FinalCTA from "../components/sections/FinalCTA";
import ServiceCard from "../components/shared/ServiceCard";
import Eyebrow from "../components/shared/Eyebrow";
import { useServices } from "../context/ServicesContext";
import { cn } from "../lib/utils";

export default function Services() {
  const { services: SERVICES } = useServices();

  // Filter chips derive from the groups actually in use, so a chip can never
  // lead to an empty list.
  const CATEGORIES = ["All", ...Array.from(new Set(SERVICES.map((s) => s.group).filter(Boolean)))];

  const [active, setActive] = useState("All");
  const filtered = SERVICES.filter(
    (s) => active === "All" || s.group === active
  );
  return (
    <>
      <PageHero
        eyebrow="Our Services"
        headline={"Professional cleaning\nfor homes and businesses."}
        intro="Nine core services covering residential, commercial, upholstery and specialised work — all delivered with the same standard."
        image="/generated/service_post_reno.png"
        imageAlt="Emilio's Solutions cleaner wiping newly installed kitchen cabinetry"
      />
      <section
        className="bg-ink py-16 md:py-20 border-t border-charcoal/50"
        data-testid="services-listing"
      >
        <div className="container-emilio">
          <Eyebrow>Filter</Eyebrow>
          <div className="mt-5 flex flex-wrap gap-2 mb-10">
            {CATEGORIES.map((c) => (
              <button
                type="button"
                key={c}
                onClick={() => setActive(c)}
                data-testid={`services-filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
                className={cn(
                  "text-xs uppercase tracking-[0.18em] px-4 py-2.5 border transition-colors",
                  active === c
                    ? "border-emerald text-emerald"
                    : "border-charcoal text-mutedtext hover:text-white hover:border-white/40"
                )}
              >
                {c}
              </button>
            ))}
          </div>
          {filtered.length === 0 ? (
            <div className="text-center py-16 border border-charcoal text-mutedtext">
              No services match this filter.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {filtered.map((s, i) => (
                <ServiceCard key={s.slug} service={s} index={i} />
              ))}
            </div>
          )}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
